var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.4 2.22l1.6-.318s-1.344 1.49-1.6 1.586c-.032.729 0 .95 0 .95C11.328 17.5 0 11.731 0 11.731c4.127.095 4.48-1.586 4.48-1.586-2.4-.349-2.88-1.902-2.88-1.902.832.38 1.28-.317 1.28-.317C.287 7.26.64 4.755.64 4.755c.447.382 1.152.54 1.567.603C1.92 5.009-.513 2.125.96.634c0 0 1.791 3.17 6.496 3.456l.32-.063c-.064-.223-.064-.445-.064-.697 0-1.84 1.503-3.33 3.36-3.33 2.24 0 2.72 1.27 2.72 1.27l1.6-.952c-.032 0-.192 1.584-.992 1.902","fill":"#041E42","fillRule":"evenodd"}));
}

Twitter.defaultProps = {"width":"16","height":"13"};

module.exports = Twitter;

Twitter.default = Twitter;
